import {CreateLastCallRequestValueObject} from './CreateLastCallRequestValueObject.js'
import {CreateLastCallResponseValueObject} from './CreateLastCallResponseValueObject.js'
import {ShowLastCallValueObject} from './ShowLastCallValueObject.js'

export class LastCallValueObjectFactory {
  static showLastCallValueObject = ({show, reason}) => new ShowLastCallValueObject({show, reason})

  static createLastCallRequestValueObject = ({adId, dealerId, makeId, postalCode, title, uniqueVehicleId, userId}) => {
    return new CreateLastCallRequestValueObject({
      adId,
      dealerId,
      makeId,
      postalCode,
      title,
      uniqueVehicleId,
      userId
    })
  }

  static createLastCallResponseValueObject = ({areDealersFar, numberOfCreatedLastCalls}) => {
    return new CreateLastCallResponseValueObject({
      isLongDistance: areDealersFar,
      lastCallsCount: numberOfCreatedLastCalls
    })
  }
}
